import href from '#utilities/js/ea/href.js'
import globals from '#utilities/js/ea/globals.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import append from '@mailobj-browser/front/js/tree/append.js'
import resolvable from '@mailobj-browser/front/js/utils/resolvable.js'

import upload from '../network/upload.js'
import local from '../storage/local.js'
import { user } from '../storage/vars.js'

const process = async (files) => {
  const [promise, { resolve }] = resolvable()
  const attachZone = one('#id_msg_attach')
  const progressModel = attachZone?.nextElementSibling?.content?.firstElementChild
  let progress
  if (progressModel) {
    progress = progressModel.cloneNode(true)
    append(attachZone, progress)
  }
  const url = href('mail/send_attach_valid', { quick_attach : 1})
  const data = await upload(url, files, progress)
  resolve(ea_parse_res(data, ''))
  return promise
}

export default async (files) => {
  const { ea_link_file, ea_link_, ea_parse_res } = globals
  const appUser = local.get(user)
  if (ea_link_file !== 'mail/send' && appUser) {
    const url = href('mail/send', { extern : 1 })
	ea_link_(url, '', async () => await process(files))
  } else {
    await process(files)
  }
}
